// project imports
import config from 'config';

// action - state management
import * as actionTypes from './actions';

export const initialState = {
    isOpen: [], // for active default menu
    fontFamily: config.fontFamily,
    borderRadius: config.borderRadius,
    opened: true,
    isAuthenticated: false,
    loading: false,
    user: [],
    LOGINUSERS: {},
    Quizz: [],
    Essay: [],
    QuizQuestion: [],
    AlredyQuiz: [],
    AllEssay: [],
    EssayWinnerEssay: [],
    EssayWinnerUsere: [],
    EssayWin: [],
    AllQuizAttempts: [],
    QuizzWinners: [],
    GetAllEssayWinners: [],
    AllStudents: [],
    isAlreadyQuizzs: [],
    sidebarShow: true,
    sidebarUnfoldable: true,
    Admins: [],
    Teachers: [],
    EssayTeachers: [],
    TeacherEssayIds: [],
    Annoucements: [],


    EssayExamContinue: [],
    QuizExamContinue: []
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const customizationReducer = (state = initialState, action) => {
    let id;
    switch (action.type) {
        case actionTypes.MENU_OPEN:
            id = action.id;
            return { ...state, isOpen: [id] };

        case actionTypes.SET_MENU:

            return { ...state, opened: action.opened };
        case actionTypes.SET_FONT_FAMILY:

            return { ...state, fontFamily: action.fontFamily };
        case actionTypes.SET_BORDER_RADIUS:

            return { ...state, borderRadius: action.borderRadius };

        case "Login":
            return { ...state, isAuthenticated: true, user: { roles: "Admin" } };

        case 'GetUser':
            return { ...state, LOGINUSERS: action.payload };

        case 'GetQuizz':
            return { ...state, Quizz: action.payload };

        case 'GetAnnoucements':
            return { ...state, Annoucements: action.payload };

        case 'GetEssay':
            return { ...state, Essay: action.payload }
        case 'QuizQuestion':
            return { ...state, QuizQuestion: action.payload };
        case 'AlredyQuiz':
            return { ...state, AlredyQuiz: action.payload }
        case 'AllEssay':
            return { ...state, AllEssay: action.payload }
        case 'EssayWinnerUsere':
            return { ...state, EssayWinnerUsere: action.payload }
        case 'EssayWinnerEssay':
            return { ...state, EssayWinnerEssay: action.payload }
        case 'EssayWin':
            return { ...state, EssayWin: action.payload }
        case 'AllQuizAttempts':
            return { ...state, AllQuizAttempts: action.payload }
        case 'QuizzWinners':
            return { ...state, QuizzWinners: action.payload }
        case 'GetAllEssayWinner':
            return { ...state, GetAllEssayWinners: action.payload }
        case 'AllStudent':
            return { ...state, AllStudents: action.payload }
        case 'isAlreadyQuizz':
            return { ...state, isAlreadyQuizzs: action.payload }

        case 'AllAdmin':
            return { ...state, Admins: action.payload }

        case 'AllTeachers':
            return { ...state, Teachers: action.payload }
        case 'EssayTeachers':
            return { ...state, EssayTeachers: action.payload }
        case 'TeacherEssayIds':
            return { ...state, TeacherEssayIds: action.payload }
        case 'EssayExamContinue':
            return { ...state, EssayExamContinue: action.payload }
            case 'QuizExamContinue':
                return { ...state, QuizExamContinue: action.payload }

        default:
            return state;
    }
};

export default customizationReducer;
